/**
 * @author Gerhard Wasner
 * Here go all functions which are COMMON to TimeRecord (PSB, BHG) AND the MsbTimeRecord Module
 */

export function init_datetimepicker_____ORI______() {
    // uses jquery datetimepicker gem
    $('.datepicker').datetimepicker({
        lang: 'de',
        format:'d.m.Y',
        timepicker:false,
        weeks: true,
        dayOfWeekStart: 1,
        mask: false,
        scrollYear:false,
        scrollMonth:false,
        scrollTime:false,
        scrollInput:false
    });
    $('.timepicker').datetimepicker({
        lang: 'de',
        format:'H:i',
        datepicker:false,
        timepicker:true,
        step: 5,
        mask: false,
        scrollMonth:false,
        scrollTime:true,
        scrollInput:false
    });
    $('.datetimepicker').datetimepicker({
        lang: 'de',
        format:'d.m.Y H:i',
        timepicker:true,
        weeks: true,
        dayOfWeekStart: 1,
        step: 5,
        mask: false,
        scrollYear:false,
        scrollMonth:false,
        scrollTime:true,
        scrollInput:false
    });

    $('.error').hide();
}

export function init_datetimepicker() {
    //console.log("🕒 init_datetimepicker(): initializing date/time fields...");

    // Verhindere doppelte Initialisierung
    $('.datepicker').not('.xdinit').each(function() {
        $(this).addClass('xdinit').datetimepicker({
            lang: 'de',
            format: 'd.m.Y',
            timepicker: false,
            weeks: true,
            dayOfWeekStart: 1,
            mask: false,
            scrollYear: false,
            scrollMonth: false,
            scrollTime: false,
            scrollInput: false
        });
        //console.log("   → initialized datepicker:", this.id);
    });

    $('.timepicker').not('.xdinit').each(function() {
        $(this).addClass('xdinit').datetimepicker({
            lang: 'de',
            format: 'H:i',
            datepicker: false,
            timepicker: true,
            step: 5,
            mask: false,
            scrollMonth: false,
            scrollTime: true,
            scrollInput: false
        });
        //console.log("   → initialized timepicker:", this.id);
    });

    $('.datetimepicker').not('.xdinit').each(function() {
        $(this).addClass('xdinit').datetimepicker({
            lang: 'de',
            format: 'd.m.Y H:i',
            timepicker: true,
            weeks: true,
            dayOfWeekStart: 1,
            step: 5,
            mask: false,
            scrollYear: false,
            scrollMonth: false,
            scrollTime: true,
            scrollInput: false
        });
        //console.log("   → initialized datetimepicker:", this.id);
    });

    $('.error').hide();
    //console.log("✅ init_datetimepicker(): done");
}

$.strPad = function(i,l,s) {
    if (i) {
    var o = i.toString();
    if (!s) { s = '0'; }
    while (o.length < l) {
        o = s + o;
    }
    }
    return o;
};

// ----------------------  compose_datetime --------------------------------------------------
export function compose_datetime(the_datetime, the_date, the_time, options) {
    // composes a datetime string from the_date-field & the_time field
    //console.group('compose_datetime');
    if (typeof options === 'undefined') { options = {}; }
    var all_day=is_true(options['all_day']) || false;
    var fixed_time=options['fixed_time'] || '00:00';
    var time_format=options['time_format'] || 'HH:mm';
    var day_offset=Number(options['day_offset']) || 0;
    if (all_day) {
        var t = fixed_time;
        var d = moment_date(the_date);
        d.add(day_offset, 'days');
        d = d.format('DD.MM.YYYY');
        //console.log('all_day compose_datetime', d)
    } else {
        var d = $(the_date).val();
        var t = $(the_time).val();
    }

    if (t) {
        if (!(/:/i.test(t))) {
            // only one argument given in time...
            // check length, if greater than 2, assume last 2 digitas as minutes, first 1-2 digitas as hour
            if (t.length>2) {
                var m = t.slice(-2); // last 2 digits of t
                var h = $.strPad(t.slice(0, t.length-2), 2); // first digits until 2 on the right side
                var s = '00';
            } else {
                // otherwise assume as hour
                var h = $.strPad(t, 2);
                var m = '00';
                var s = '00';
            }
        } else {
            var ts = t.split(':');
            var h = $.strPad(ts[0], 2);
            var m = $.strPad(ts[1], 2);
            var s = $.strPad(ts[2], 2);
        }
        if (time_format=='HH:mm:ss') {
            m = moment(String(h) + ':' + String(m) + ':' + String(s), time_format, true);
        } else if (time_format=='HH:mm') {
            m = moment(String(h) + ':' + String(m), time_format, true);
        }

        /*console.log(
            'compose_datetime',
            'time_format', time_format,
            'all_day', all_day,
            '/:/i.test(t) =', /:/i.test(t),
            't:', t,
            'ts:', ts,
            'ts[0]:', ts ? ts[0] : '(undef)',
            'h:', h,
            'ts[1]:', ts ? ts[1] : '(undef)',
            'm:', m,
            'm.isValid():', m && m.isValid ? m.isValid() : '(no moment)'
        );
         */

        if (m.isValid()) {
            $(the_time).val(m.format(time_format));
            $(the_datetime).val(d + ' ' + t);
            var validation = true;

        } else {
            $(the_time).val('');
            $(the_datetime).val(d + ' 00:00:00');
            var validation = false;
        }
        //console.log('compose_datetime after validation ', '$(the_time).val(): ', $(the_time).val());

    } else {
        // reset composite field
        $(the_datetime).val('');
    }
    return validation;
}



// ----------------------  moment_correct_dauer_for_dst --------------------------------------------------
export function moment_correct_dauer_for_dst(from_id, to_id) {
    // corrects dauer for Daylight Saving Time changes
    // problem: 00:00-06:00  yields dauer 7h  on change to Winterzeit in October -> correct -1 hour
    //                                    5h on change to Sommerzeit in March    -> correct +1 hour
    // returns correction of one hour as milliseconds

    var m_from=moment(moment_date(from_id));
    var m_to=moment(moment_date(to_id));

    var sd=moment(lastSundayOfMonth(m_to.year(), 3)+' 02:00', 'YYYY-MM-DD HH:mm');
    var wd=moment(lastSundayOfMonth(m_to.year(), 10)+' 02:00', 'YYYY-MM-DD HH:mm');

    correct_dauer_ms=0;
    //  if von<Sunday 2:00 AND bis>=Sunday 2:00  -> correct
    if (m_from.isBefore(wd) && (m_to.isAfter(wd) || m_to.isSame(wd))) {
        // bis Date is day of change to WinterTime
        //console.log('DST Winterzeitumstellung: '+wd.format('DD.MM.YYYY'));
        var correct_dauer_ms=-1000*60*60;

    } else if (m_from.isBefore(sd) && (m_to.isAfter(sd) || m_to.isSame(sd))) {
        // bis Date is day of change to SummerTime
        //console.log('DST Sommerzeitumstellung:  '+sd.format('DD.MM.YYYY'));
        var correct_dauer_ms=+1000*60*60;
    }
    return correct_dauer_ms;  // time difference in Milliseconds
}



// ----------------------  calculate_dauer --------------------------------------------------
export function calculate_dauer(time_from, time_to, dauer, the_focus, all_day = false) {
    // Normal: compute millisecond difference
    let d_ms;
    //
    // --- GANZTAG LOGIK ---
    //
    d_ms = moment_correct_dauer_for_dst(time_from, time_to);

    if (is_true(all_day)) {
        compose_datetime(time_from, '#von_date', '#von_time', { all_day: all_day });
        compose_datetime(time_to, '#bis_date', '#bis_time', { all_day: all_day, day_offset: 1 });

        // Dauer = Differenz + 1 Tag
        d_ms += moment_get_duration('#von_date', '#bis_date') + (1000 * 60 * 60 * 24);

        const days = d_ms / 1000 / 60 / 60 / 24;

        $('#dauer_info').html(days.toFixed(0) + (days === 1 ? ' Tag' : ' Tage'));
        $('#record_dauer').val(days);

        return days;
    }

    //
    // --- NORMALE BERECHNUNG ---
    //

    d_ms += moment_get_duration(time_from, time_to);

    if ($(time_from).val() && $(time_to).val() && d_ms > 0) {
        const minutes = d_ms / 1000 / 60;
        const hours = minutes / 60;

        $(dauer).val(hours);
        $('#value_' + dauer.substring(1)).text(minutes + 'min');

        return hours;
    } else {
        // Keine Dauer → optional reset
        // reset_dauer(dauer);  // nur aktivieren falls gewünscht
        return 0;
    }
}

export function record_is_all_day() {
    is_true($('#record_all_day').val());
}

export function moment_date(id) {
    var m=moment_date_and_time('date',id);
    return m;
}

export function moment_time(id) {
    var m=moment_date_and_time('time',id);
    return m;
}

export function moment_datetime(id) {
    var m=moment_date_and_time('datetime',id);
    return m;
}

export function moment_date_and_time(moment_type, id) {
    // reads a datepicker text_field with german date-time-format
    // returns a moment date-object
    // uses moment.js
    switch(moment_type) {
        case 'date':
            var f = 'DD.MM.YYYY';
            break;
        case 'time':
            var f = 'HH:mm:ss';
            break;
        case 'datetime':
            var f = 'DD.MM.YYYY HH:mm';
            break;
    }

    var m=moment($(id).val(), f); // true as third parameter, use strict parsing
    return m;
}


export function moment_date_validation(id, error_message, submit_buttons, future, aggregated_mode) {
    return moment_date_and_time_validation('date', id, error_message, submit_buttons, future, aggregated_mode);
}

export function moment_time_validation(id, error_message, submit_buttons, future, aggregated_mode) {
    return moment_date_and_time_validation('time', id, error_message, submit_buttons, future, aggregated_mode);
}

export function moment_datetime_validation(id, error_message, submit_buttons, future, aggregated_mode) {
    return moment_date_and_time_validation('datetime', id, error_message, submit_buttons, future, aggregated_mode);
}

export function moment_date_and_time_validation(moment_type, id, error_message, submit_buttons, future, aggregated_mode) {
    // validates a date/time/datetime via moment.js
    var m = moment_date_and_time(moment_type, id);
    var valid = true;
    var message = '';

    // --- Validation logic ---------------------------------------------------

    // Empty field → valid
    if ($(id).val() === '') {
        valid = true;
    }
    // Invalid Moment object → error
    else if (!m.isValid()) {
        valid = false;
        message = error_message;
    }
    // No-future constraint
    else if (typeof future === 'string' && future === 'no_future_dates' && m.isAfter(moment(), 'minute')) {
        valid = false;
        message = error_message + " (Datum darf nicht in der Zukunft liegen)";
    }

    // --- Aggregated mode ----------------------------------------------------
    if (aggregated_mode) {
        // return structured result, no UI manipulation
        return { success: valid, message: message };
    }

    // --- Standalone mode ----------------------------------------------------
    if (valid) {
        $("label[for='" + id + "']").removeClass('error');
        $(id + "_error").text('').hide();
        enableUiButtons(submit_buttons);
    } else {
        $("label[for='" + id + "']").addClass('error');
        $(id + "_error").show().text(message);
        disableUiButtons(submit_buttons);
    }

    return valid;
}


export function moment_date_range_validation(id_from, id_to, error_message, submit_buttons, aggregated_mode) {
    var res = moment_date_and_time_range_validation('date', id_from, id_to, error_message, submit_buttons, aggregated_mode);
    return res;
}

export function moment_time_range_validation(id_from, id_to, error_message, submit_buttons, aggregated_mode) {
    var res = moment_date_and_time_range_validation('time', id_from, id_to, error_message, submit_buttons, aggregated_mode);
    return res;
}

export function moment_datetime_range_validation(id_from, id_to, error_message, submit_buttons, aggregated_mode) {
    var res = moment_date_and_time_range_validation('datetime', id_from, id_to, error_message, submit_buttons, aggregated_mode);
    return res;
}


export function moment_date_and_time_range_validation(moment_type, id_from, id_to, error_message, submit_buttons, aggregated_mode) {
    // validates if id_to-Date is after id_from-Date
    var from_date = moment_date_and_time(moment_type, id_from);
    var to_date   = moment_date_and_time(moment_type, id_to);
    var error_field = id_from + "_to_" + id_to.replace('#', '') + "_error";
    var valid = true;
    var message = '';

    // Prüflogik
    if (from_date && to_date && moment(to_date).isBefore(from_date, 'minute')) {
        valid = false;
        message = error_message;
    }

    // Aggregationsmodus aktiv → kein direktes UI-Update
    if (aggregated_mode) {
        return { success: valid, message: message };
    }

    // Normalmodus (UI wird direkt manipuliert)
    if (!valid) {
        $(error_field).show();
        $(error_field).text(error_message);
        disableUiButtons(submit_buttons);
    } else {
        $(error_field).text("");
        $(error_field).hide();
        enableUiButtons(submit_buttons);
    }

    return valid;
}



export function moment_date_in_year_validation(id_from, id_to, id_year, error_message, submit_button) {
    // validates if the year of id_from Date and id_to Date are the value of id_year
    // uses moment.js
    // c:240108
    var moment_type='date';
    var from_date=moment_date_and_time(moment_type, id_from);
    var to_date=moment_date_and_time(moment_type, id_to);
    var the_year=$(id_year).val();
    // console.log('from_date.year():'+from_date.year()+', the_year:'+the_year);
    var res0;
    var res1;
    //
    if (from_date.year()!=the_year) {
        $(id_from+'_error').show();
        $(id_from+'_error').text(error_message);
        $(submit_button).addClass("disabled");
        res0=false;
    } else {
        $(id_from+'_error').text("");
        $(id_from+'_error').hide();
        $(submit_button).removeClass("disabled");
        res0=true;
    }

    if (to_date.year()!=the_year) {
        $(id_to+'_error').show();
        $(id_to+'_error').text(error_message);
        $(submit_button).addClass("disabled");
        res1=false;
    } else {
        $(id_to+'_error').text("");
        $(id_to+'_error').hide();
        $(submit_button).removeClass("disabled");
        res1=true;
    }

    return res0&&res1;
}


export function moment_get_duration(id_from, id_to) {
    moment.locale('de');
    var bis=moment_datetime(id_to);
    var von=moment_datetime(id_from);

    var ms=moment(bis).diff(moment(von));
    return ms;
}



export function moment_set_weekday(weekday_id, date_id) {
    moment.locale('de');
    $(weekday_id).html(moment(moment_date(date_id)).format("ddd"));
}

export function moment_days_in_year(id) {
    // gibt Anzahl der Tage im jahr zurück - Schaltjahr?
    // uses moment.js
    var m=moment_date(id);
    if (m.isLeapYear()) {
        return 366;
    } else {
        return 365;
    }
}



export function lastSundayOfMonth(year, month) {
    // based on  http://rosettacode.org/wiki/Find_the_last_Sunday_of_each_month#JavaScript

    var lastDay = [31,28,31,30,31,30,31,31,30,31,30,31];
    if (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0)) lastDay[2] = 29;
    var date = new Date();
    if (isNaN(year))
        year = date.getFullYear();
    date.setFullYear(year, (Number(month)-1), lastDay[(Number(month)-1)]);
    date.setDate(date.getDate()-date.getDay());
    //console.log('lastSundayOfMonth',year, month,lastDay[(Number(month)-1)], date, date.toISOString().substring(0,10));
    return date.toISOString().substring(0,10);
}




// -------------------------  set_workdays --------------------------------------------------
	export function set_workdays(von, bis) {
		// returns number of workdays in the timespan von-bis from the_days via AJAX
		var dd_von = moment($(von).val(), 'DD.MM.YYYY');
        var dd_bis = moment($(bis).val(), 'DD.MM.YYYY');
        if (dd_von.isValid() && dd_bis.isValid()) {
            var res=$.post('/the_days/ajax_get_workdays',
                {dd_von: dd_von.format('YYYY-MM-DD'),
                 dd_bis: dd_bis.format('YYYY-MM-DD')})
                .fail(function() {
                    //alert( 'Ajax Funktion /the_days/ajax_get_workdays war leider nicht erfolgreich');
                });
           // console.log(res);
	    }
	}



// -----------------------  check_for_available_date --------------------------------------------------
	export function check_for_available_date(the_object, the_field){
        //  update view with RJS template
        //  direct update after with-block{}:      , function(data) {$('#dom_element_to_update_html').html(data);}
        //console.log('BEGIN check_for_available_date');
        var institution_id=compound_id($('#record_client_id').val(), 'i');
        //console.log("institution_id from compound_id: "+institution_id);
        if (institution_id==null || institution_id==undefined) {
            institution_id=$('#default_institution_for_employee').val();
        }
        //console.log("institution_id: "+institution_id);
        //console.log(the_object+'_'+the_field+": "+$('#'+the_object+'_'+the_field).val());
        //console.log('record_employee_id: '+$('#record_employee_id').val());
        //console.log("institution_id from #default_institution_for_employee:"+institution_id);
        if ($("#"+the_field+"_date_region").is(':visible') && $('#record_employee_id').val() && institution_id) {
            //console.log("check_for_available_date #"+the_field+"_date_region is :visible")
			var dd=moment($('#'+the_object+'_'+the_field).val(), 'DD.MM.YYYY')
            //console.log("dd:"+dd.format('YYYY-MM-DD'));
            if (dd.isValid()) {
                //console.log("AJAX CALL /time_records/ajax_check_docu_date");
                var res=$.post('/time_records/ajax_check_docu_date',
                        {dd: dd.format('YYYY-MM-DD'),
                        task: $('#record_task_id').val(),
                        employee: $('#record_employee_id').val(),
                        institution: institution_id})
                    .fail(function() {
                        //console.log('Ajax Funktion /time_records/ajax_check_docu_date war leider nicht erfolgreich');
                    });

	        }
		} else {
            //console.log('check_for_available_date wurde nicht durchgeführt');
        }
    }



// -----------------------  get_available_docus --------------------------------------------------
export function get_available_docus(callback) {
    if ($('#record_client_id').val() != '') {
        // 260511nrai: race fix - on slow networks/dev the user can type into docu tabs while this
        // request is still in flight; the response then wipes #form_element_docus and silently
        // erases everything the user entered (often unnoticed because the lost data lived on an
        // inactive tab). Cover the area until the response lands so typing is impossible during
        // the wait, and abort any prior request so a stale response cannot clobber the latest.
        if (window.__getAvailableDocusInFlight && typeof window.__getAvailableDocusInFlight.abort === 'function') {
            try { window.__getAvailableDocusInFlight.abort(); } catch (e) {}
        }

        if (typeof dimmed_element === 'function') {
            dimmed_element('#form_element_docus', 'show');
        }

        window.__getAvailableDocusInFlight = $.post('/time_records/ajax_get_available_docus', {
            clients_institutions: $('#record_client_id').val(),
            task: $('#record_task_id').val(),
            employee: $('#record_employee_id').val()
        })
        .done(function() {
            if (typeof callback === 'function') {
                callback();
            }
        })
        .fail(function() {
            // console.log('Ajax Funktion /time_records/ajax_get_available_docus war leider nicht erfolgreich');
        })
        .always(function() {
            window.__getAvailableDocusInFlight = null;
            if (typeof dimmed_element === 'function') {
                dimmed_element('#form_element_docus', 'hide');
            }
        });
    }
}


// -----------------------  get_ziele_warning ------------------- DEPRECATED -------------------------------
export function get_ziele_warning(){
    // update view with RJS template
    // console.log('get_ziele_warning START')

    if ($('#record_client_id').val()!='') {
        // console.log('get_ziele_warning $.post() START')
        $.post('/time_records/ajax_get_ziele_warning',
            { clients_institutions: $('#record_client_id').val() })
            .fail(function() {
                // console.log('Ajax Funktion /time_records/ajax_get_ziele_warning war leider nicht erfolgreich');
            });
    }
}


// -----------------------  get_ziele_warning --------------------------------------------------
export function get_docus_gascales_warning(){
    // update view with RJS template
    // console.log('get_docus_gascales_warning START')

    if ($('#record_client_id').val()!='') {
        // console.log('get_docus_gascales_warning $.post() START')
        $.post('/time_records/ajax_get_docus_gascales_warning',
            { clients_institutions: $('#record_client_id').val() })
            .fail(function() {
                // console.log('Ajax Funktion /time_records/ajax_get_docus_gascales_warning war leider nicht erfolgreich');
            });
    }
}

// -----------------------  get_fehlkontakte_warning --------------------------------------------------
export function get_call_client_button(){
    // update view with RJS template
    // console.log('get_call_client_button START')

    if ($('#record_client_id').val()!='') {
        // console.log('get_call_client_button $.post() START')
        $.post('/time_records/ajax_get_call_client_button',
            { clients_institutions: $('#record_client_id').val(),
              task: $('#record_task_id').val()})
            .fail(function() {
                // console.log('Ajax Funktion /time_records/ajax_get_call_client_button war leider nicht erfolgreich');
            });
    }
}



// -----------------------  get_fehlkontakte_warning --------------------------------------------------
export function get_client_data(){
    // update view with RJS template
    // console.log('get_client_data START')

    if ($('#record_client_id').val()!='') {
        // console.log('get_client_data $.post() START')
        $.post('/time_records/ajax_get_client_data',
            { clients_institutions: $('#record_client_id').val(), domain_code: $('#domain_code').val()})
            .fail(function() {
                // console.log('Ajax Funktion /time_records/ajax_get_client_data war leider nicht erfolgreich');
            });
    }
}


// -----------------------  get_contact_type --------------------------------------------------
	export function get_contact_type(){
		// update view with RJS template
        // console.log('get_contact_type START')
        $('#form_element_contact_type').html('');
        $('#record_contact_type').val('');
        var dd=moment($('#von_date').val(), 'DD.MM.YYYY');
        if (dd.isValid() && $('#record_client_id').val()!='' && $('#record_task_id').val()!='') {
            // console.log('get_contact_type $.post() START')
            $.post('/time_records/ajax_get_contact_type',
                {date: dd.format('YYYY-MM-DD'),
                 clients_institutions: $('#record_client_id').val(),
                 task: $('#record_task_id').val(),
                 ids: $('#ids').val()})
                .fail(function() {
                    // console.log('Ajax Funktion /time_records/ajax_get_contact_type war leider nicht erfolgreich');
                });
	    }
    }



// -----------------------  get_fehlkontakte_warning --------------------------------------------------
export function get_fehlkontakte_warning(){
    // update view with RJS template
    // console.log('get_fehlkontakte_warning START')

    if ($('#record_client_id').val()!='') {
        // console.log('get_fehlkontakte_warning $.post() START')
        $.post('/time_records/ajax_get_fehlkontakte_warning',
            { clients_institutions: $('#record_client_id').val(),
                task: $('#record_task_id').val()})
            .fail(function() {
                // console.log('Ajax Funktion /time_records/ajax_get_fehlkontakte_warning war leider nicht erfolgreich');
            });
    }
}


// ------------------------  enable_edit_client_button ----------------------------

export function enable_edit_person_button(selectSelector, buttonSelector, resourceName) {
    var $select = $(selectSelector);
    var $button = $(buttonSelector);
    var value = $select.val();

    // Determine person_id depending on resource type
    var person_id;
    if (resourceName === 'clients') {
        person_id = compound_id(value, 'c');
    } else {
        person_id = value;
    }

    // Show button only if a valid single numeric ID is selected
    if (value !== '' && typeof(person_id) === 'number') {
        $button.show();
    } else {
        $button.hide();
    }

    // Remove previous click handlers to prevent duplicates
    $button.off('click').on('click', function() {
        if (typeof(person_id) === 'number') {
            var url = "/" + resourceName + "/" + person_id + "/edit?popup=true";
            popup_window(
                url,
                "badok_" + resourceName + "_edit",
                1240,
                940,
                window.screenLeft + (window.outerWidth - 1240) / 2,
                window.screenTop + 50
            );
        }
    });
}

export function enable_edit_client_button() {
    enable_edit_person_button('#record_client_id', '#edit_client_button', 'clients');
}


export function enable_edit_employee_button() {
    enable_edit_person_button('#record_employee_id', '#edit_employee_button', 'employees');
}


export function cleanEmptySelect2Entries(selector) {
    var $el = $(selector);
    var values = $el.val();

    if (Array.isArray(values)) {
        // Remove falsy or empty values
        var cleaned = values.filter(function(v) {
            return v && $.trim(v) !== '';
        });

        if (cleaned.length !== values.length) {
            $el.val(cleaned).trigger('change.select2');
        }
    }
}


// ------------------------  set_clients_select_list_to_multiple ----------------------------


export function set_person_select_list_to_multiple(selectSelector, searchSelector, resourceName, multipleFlag1Selector, multipleFlag2Selector) {
    var $select = $(selectSelector);
    var $search = $(searchSelector);

    $select.show();

    if ($select.length === 0 || !$select.is('select') || !$select.is(':visible')) {
        return; // Exit silently — nothing to do
    }

    // Determine if multiple selection should be enabled
    var enableMultiple =
        $(multipleFlag1Selector).val() === 'true' ||
        $(multipleFlag2Selector).val() === 'true';

    if (enableMultiple) {
        if ($search.length > 0 && $search.is(':visible')) {
            $search.hide();
        }
        $select.attr('multiple', true);
        $select.attr('size', 20);

        // Initialize select2
        $select.select2({
            placeholder: resourceName === 'clients' ? "KlientInnen auswählen" : "MitarbeiterInnen auswählen",
            allowClear: true,
            tags: true,
            tokenSeparators: [','],
            language: "de"
        })
            // Prevent empty entries
            .off('select2:selecting').on('select2:selecting', function(e) {
            if (!e.params.args.data.id || $.trim(e.params.args.data.id) === '') {
                e.preventDefault();
            }
        })
            // Cleanup on close
            .off('select2:close').on('select2:close', function() {
            cleanEmptySelect2Entries(selectSelector);
        });

        // Limit results box height
        $("#select2-" + $select.attr('id') + "-results")
            .css("max-height", "400px")
            .css("height", "400px");

    } else {
        // Revert to single select
        if ($search.length > 0) {
            $search.show();
        }
        $select.attr('multiple', false);
        $select.attr('size', 1);
        $select.removeClass('select2-hidden-accessible');
        $('#ajaxed_' + resourceName).find('.select2').hide();
        $('.select2-container').hide();
    }

    // Re-enable edit button logic for that resource
    if (resourceName === 'clients') {
        enable_edit_client_button();
    } else if (resourceName === 'employees') {
        enable_edit_employee_button();
    }
}

export function set_clients_select_list_to_multiple() {
    set_person_select_list_to_multiple(
        '#record_client_id',
        '#search_client',
        'clients',
        '#task_multiple_people',
        '#set_client_select_multiple'
    );
}

export function set_employees_select_list_to_multiple() {
    set_person_select_list_to_multiple(
        '#record_employee_id',
        '#search_employee',
        'employees',
        '#task_multiple_employees',
        '#set_employee_select_multiple'
    );
}

export function extractInstitutionId(optionValue) {
    // expect patterns like: i_12345__c_546
    // or i_999__c_0
    const match = String(optionValue).match(/^i_(\d+)__c_\d+$/);

    if (match) {
        return match[1]; // the institution ID
    } else {
        return null; // pattern not recognized
    }
}


// ----------------------  adapt_client_list_for_task --------------------------------------------------
export function adapt_client_list_for_task() {
    // called by element_task_properties, form_element_client
    //------ V2 - always show clientlist, disable clients, leave only 'OHNE KlientIn' -----------
    var $search = $('#search_client');

    //console.log("=== TASK CLIENT FORBIDDEN CHECK ===");
    //console.log("task_client_forbidden:", $('#task_client_forbidden').val());
    //console.log("search element exists:", $search.length > 0, "visible:", $search.is(':visible'));
    //console.log("select exists:", $select.length > 0, "visible:", $select.is(':visible'), "nodeName:", $select.prop('nodeName'));

    if ($('#task_client_forbidden').val() === 'true') {

        //console.log("→ Entering forbidden branch");
        set_clients_select_list_to_multiple();

        // LOG after init
        //console.log("After set_clients_select_list_to_multiple:");
        //console.log("  select visible:", $select.is(':visible'));
        //console.log("  select2 container visible:", $('.select2-container').is(':visible'));

        if ($search.length > 0 && $search.is(':visible')) {
            //console.log("Hiding search field");
            $search.hide();
        }

        var currentInstitution = $('#current_institution_for_time_records').val();
        //console.log("currentInstitution:", currentInstitution);

        var selectedOption = null;
        var countAll = 0;
        var countC0 = 0;
        var countEnabledC0 = 0;

        $('#record_client_id option').each(function() {
            var val = $(this).val();
            countAll++;

            if (!val) return;

            if (val.match(/_c_0$/)) { countC0++; }

            // Disable non c_0
            if (!val.match(/_c_0$/)) {
                $(this).prop('disabled', true);
                //console.log("DISABLE:", val);
            } else {
                $(this).prop('disabled', false);
                countEnabledC0++;
                //console.log("ENABLE:", val);

                // Check match by institution
                if (currentInstitution &&
                    val.indexOf('i_' + currentInstitution + '__c_0') === 0) {

                    //console.log("MATCH for institution:", val);
                    selectedOption = $(this);
                }

                // fallback if no institution
                if (!currentInstitution && !selectedOption) {
                    selectedOption = $(this);
                    //console.log("FALLBACK first _c_0:", val);
                }
            }
        });

        //console.log("Total options:", countAll);
        //console.log("_c_0 options:", countC0);
        //console.log("Enabled _c_0 options:", countEnabledC0);
        //console.log("selectedOption:", selectedOption ? selectedOption.val() : "NONE");


        // NOTE: selection is disabled right now for debugging
        $('#record_client_id').val(null).trigger('change.select2');

        if (!selectedOption || selectedOption.length === 0) {
            selectedOption = $('#record_client_id option[value$="_c_0"]').first();
            $('#current_institution_for_time_records').val(extractInstitutionId(selectedOption));
            $('#record_institution_id').val(extractInstitutionId(selectedOption));
        }
        if (selectedOption && selectedOption.length > 0) {
            $('#record_client_id').val(selectedOption.val()).trigger('change.select2');
        }

        // After selection attempt
        //console.log("After potential selection:");
        //console.log("  select visible:", $select.is(':visible'));
        //console.log("  select2 container visible:", $('.select2-container').is(':visible'));

    } else {

        //console.log("→ Entering NON-forbidden branch");

        $('#record_client_id option').prop('disabled', false);
        set_clients_select_list_to_multiple();

        if ($search.length > 0) {
            $search.show();
        }

        //console.log("After enabling:");
        //console.log("  select visible:", $select.is(':visible'));
        //console.log("  select2 container visible:", $('.select2-container').is(':visible'));

    }
}


export function syncCurrentInstitutionWithSelectedClient() {

    const $select = $('#record_client_id');
    const selectedVal = $select.val();   // might be null, "" or array (for multiple)

    // If select2 or multiselect returns array → pick first element
    const selected = Array.isArray(selectedVal) ? selectedVal[0] : selectedVal;

    // No selection → auto-select first _c_0 client
    if (!selected) {
        //console.log("No client selected → fallback to select_first_ohne_klient()");
        select_first_ohne_klient();
        return;
    }

    // Extract institution from selected option
    const instFromClient = extractInstitutionId(selected);

    if (!instFromClient) {
        //console.warn("Could not extract institution from:", selected);
        return;
    }

    const currentInst = $('#current_institution_for_time_records').val();

    // Compare old and new institution; if different → update
    if (currentInst !== instFromClient) {
        //console.log(`Updating current institution: ${currentInst} → ${instFromClient}`);
        $('#current_institution_for_time_records').val(instFromClient);
    }

    const recordInst = $('#record_institution_id').val();

    // Compare old and new institution; if different → update
    if (recordInst !== instFromClient) {
        //console.log(`Updating record institution: ${recordInst} → ${instFromClient}`);
        $('#record_institution_id').val(instFromClient);
    }
}


// ----------------------  hide_elements_for_task --------------------------------------------------
export function hide_elements_for_task() {
    // Retrieve the space-separated value of task_hide_form_elements
    var hideFormElements = $('#task_hide_form_elements').val(); // Value of the hidden field
    var hiddenElementsArray = hideFormElements ? hideFormElements.split(' ') : []; // Convert to an array

    if (hiddenElementsArray.includes('client')) {
        if ($('#form_element_client').is(':visible')) {
            //console.log("Hiding form_element_client");
            $('#form_element_client').hide();
        }
    } else {
        if (!$('#form_element_client').is(':visible')) {
            //console.log("Showing form_element_client");
            $('#form_element_client').show();
        }
    }

    // Array of all hideable elements
    var otherHideableElements = ['kurzdoku', 'geheimnisdoku', 'contact_status', 'km_telefonate_kontakte'];

    // Iterate over each hideable element
    otherHideableElements.forEach(function(element) {
        var selector = '#form_element_' + element; // Build the selector dynamically
        if (hiddenElementsArray.includes(element)) {
            $(selector).hide(); // Hide the element if in the hiddenElementsArray
            //console.log(selector+' hide()');
        } else {
            $(selector).show(); // Otherwise, show the element
            //console.log(selector+' show()');
        }
    });
}




// ----------------------  ajax_set_session_pref --------------------------------------------------
export function ajax_set_session_pref(key, value) {
    $.post('/prefs/ajax_set',
        {key: key, value: value})
        .fail(function() {
            // console.log('ajax_set_session_pref', 'Die Funktion /prefs/ajax_set für '+key+' und '+value+' war leider nicht erfolgreich');
        });
}



// ----------------------  ajax_edit_time_record --------------------------------------------------
export function ajax_edit_time_record(controller_name, time_record_id) {
    $.post('/'+controller_name+'/ajax_edit',
        {id: time_record_id})
        .fail(function() {
            // console.log('ajax_edit_time_record',  'Die Funktion /'+controller_name+'/ajax_edit war leider nicht erfolgreich');
        });
}




// ----------------------  ajax_get_tasks --------------------------------------------------
export function ajax_get_tasks() {

    $.post('/time_records/ajax_get_tasks',
        {
            institution: $('#record_institution_id').val(),
            employee:    $('#record_employee_id').val(),
            current_institution_for_time_records: $('#current_institution_for_time_records').val(),
            current_domain_for_time_records: $('#current_domain_for_time_records').val()
             })
        .fail(function() {
            // console.log('ajax_get_tasks',  'Die Funktion /time_records/ajax_get_tasks war leider nicht erfolgreich');
        });
}




// ----------------------  ajax_lookup_client --------------------------------------------------
export function ajax_lookup_client() {
    //console.log('ajax_lookup_client', $('#record_client_id').val());
    // controller-dependend path results in a loop of form_element_* updates
    // (institution-client-task, institution, client.....)
    var von=$('#record_von').val() || ($('#von_date').val()+' 00:00:00' );

    $.post('/'+($('#time_records_controller').val() || 'time_records')+'/ajax_lookup_client',
        {
            institution: $('#record_institution_id').val(),
            employee:    $('#record_employee_id').val(),
            client:      $('#record_client_id').val(),
            project:     $('#record_project_id').val(),
            task:        $('#record_task_id').val(),
            von:        von })
        .fail(function() {
            // console.log('ajax_lookup_client',  'Die Funktion /time_records/ajax_lookup_client war leider nicht erfolgreich');
        });
}


// ----------------------  ajax_lookup_institution FILTER --------------------------------------------------
export function ajax_lookup_institution_filter() {
    //console.log("$('#institution').val(): "+$('#institution').val());
    var von=$('#record_von').val() || ($('#von_date').val()+' 00:00:00' );
    $.post('/'+($('#time_records_controller').val() || 'time_records')+'/ajax_lookup_institution_filter',
        {
            institution: $('#institution').val(),
            employee:    $('#record_employee_id').val(),
            client:      $('#record_client_id').val(),
            project:     $('#record_project_id').val(),
            task:        $('#record_task_id').val(),
            von:        von})
        .fail(function() {
            // console.log('ajax_lookup_institution_filter', 'Die Funktion /time_records/ajax_lookup_institution_filter war leider nicht erfolgreich');
        });
}


// ----------------------  ajax_lookup_institution --------------------------------------------------
export function ajax_lookup_institution() {
    //console.log("$('#record_institution_id').val(): "+$('#record_institution_id').val());
    var von=$('#record_von').val() || ($('#von_date').val()+' 00:00:00' );
    $.post('/'+($('#time_records_controller').val() || 'time_records')+'/ajax_lookup_institution',
        {
            institution: $('#record_institution_id').val(),
            employee:    $('#record_employee_id').val(),
            client:      $('#record_client_id').val(),
            project:     $('#record_project_id').val(),
            task:        $('#record_task_id').val(),
            von:        von})
        .fail(function() {
            // console.log('ajax_lookup_institution', 'Die Funktion /time_records/ajax_lookup_institution war leider nicht erfolgreich');
        });
}



// ----------------------  ajax_lookup_employee --------------------------------------------------
export function ajax_lookup_employee() {
    var von=$('#record_von').val() || ($('#von_date').val()+' 00:00:00' );
    //console.log('ajax_lookup_employee', $('#record_employee_id').val());
    $.post('/'+($('#time_records_controller').val() || 'time_records')+'/ajax_lookup_employee',
        {
            institution: $('#record_institution_id').val(),
            employee:    $('#record_employee_id').val(),
            client:      $('#record_client_id').val(),
            project:     $('#record_project_id').val(),
            task:        $('#record_task_id').val(),
            von:        von})
        .fail(function() {
            // console.log('ajax_lookup_employee',  'Die Funktion /'+time_records_controller+'/ajax_lookup_employee war leider nicht erfolgreich');
        });
}



// ----------------------  ajax_lookup_task --------------------------------------------------
export function ajax_lookup_task(callback) {
    var von = $('#record_von').val() || ($('#von_date').val() + ' 00:00:00');

    // Return the jqXHR so `await` works
    return $.ajax({
        type: 'POST',
        url: '/' + ($('#time_records_controller').val() || 'time_records') + '/ajax_lookup_task.js',
        data: {
            institution: $('#record_institution_id').val(),
            employee: $('#record_employee_id').val(),
            client: $('#record_client_id').val(),
            project: $('#record_project_id').val(),
            task: $('#record_task_id').val(),
            von: von
        },
        dataType: 'script' // this is what executes ajax_lookup_task.js.erb automatically
    })
        .done(function() {
            if (typeof callback === 'function') {
                callback();
            }
        })
        .fail(function(xhr, status, error) {
            //console.log('ajax_lookup_task', 'Die Funktion /time_records/ajax_lookup_task war leider nicht erfolgreich', status, error);
        });
}



// ----------------------  ajax_lookup_contact_type --------------------------------------------------
export function ajax_lookup_contact_type() {
    var von=$('#record_von').val() || ($('#von_date').val()+' 00:00:00' );
    $.post('/'+($('#time_records_controller').val() || 'time_records')+'/ajax_lookup_contact_type',
        {
            contact_type: $('#contact_type').val(),
            institution: $('#record_institution_id').val(),
            employee:    $('#record_employee_id').val(),
            client:      $('#record_client_id').val(),
            project:     $('#record_project_id').val(),
            task:        $('#record_task_id').val(),
            von:        von})
        .fail(function() {
            // console.log('ajax_lookup_contact_type', 'Die Funktion /time_records/ajax_lookup_contact_type war leider nicht erfolgreich');
        });
}


// ----------------------  ajax_lookup_contact_status --------------------------------------------------
export function ajax_lookup_contact_status() {

    $.post('/'+($('#time_records_controller').val() || 'time_records')+'/ajax_lookup_contact_status',
        {
            contact_status: $('#record_contact_status_id').val(),
            von:        $('#record_von').val()})
        .fail(function() {
            // console.log('ajax_lookup_project',  'Die Funktion /time_records/ajax_lookup_contact_status war leider nicht erfolgreich');
        });
}



// ----------------------  ajax_lookup_contact_status --------------------------------------------------
export function ajax_lookup_fahrzeug() {
    $.post('/'+($('#time_records_controller').val() || 'time_records')+'/ajax_lookup_fahrzeug',
        {
            fahrzeug: $('#record_fahrzeug').val() })
        .fail(function() {
            // console.log('ajax_lookup_fahrzeug',  'Die Funktion /time_records/ajax_lookup_fahrzeug war leider nicht erfolgreich');
        });
}



// ----------------------  ajax_lookup_project --------------------------------------------------
export function ajax_lookup_project() {
    var von=($('#record_von').val() || ($('#von_date').val()+' 00:00:00'));
    $.post('/'+($('#time_records_controller').val() || 'time_records')+'/ajax_lookup_project',
        {
            institution: $('#record_institution_id').val(),
            employee:    $('#record_employee_id').val(),
            client:      $('#record_client_id').val(),
            project:     $('#record_project_id').val(),
            task:        $('#record_task_id').val(),
            von:        von})
        .fail(function() {
            // console.log('ajax_lookup_project',  'Die Funktion /time_records/ajax_lookup_project war leider nicht erfolgreich');
        });
}



export function set_time_record_form_submit_button() {
    let num_errors = 0;

    $('[id^="form_eval_error_for_"]').each(function() {
        const val = $(this).val();
        const isError = (val === 'true' || val === true || val === '1' || val === 1);
        //console.log("check:", this.id, "=", val, "=> isError:", isError);
        if (isError) num_errors++;
    });

    if (num_errors > 0) {
        //console.log("Disabling submit button...");
        disableUiButtons('#submit_button');
    } else {
        //console.log("Enabling submit button...");
        enableUiButtons('#submit_button');
    }
}
	

